import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Cursus} from '../../cursus.model';
import {CALENDAR_FR} from '../../../../shared/calendar/calendar.constants';
import {Departement} from '../../../grhum';
import {Pays} from '../../../grhum';
import {TypeFormation} from '../../../grhum';
import {GrhumService} from '../../../grhum';
import {Response} from '@angular/http';
import {GradeUniversitaire} from '../../../grhum';
import {NiveauAccesDiplome} from '../../../grhum';
import {GMention} from '../../../grhum';
import {FormationService} from '../../../formation';
import {CandidatureFormationService} from '../../candidature-formation.service';
import {CONSTANTS} from '../../../../cadens.constants';

@Component({
    selector: 'jhi-cursus-component',
    templateUrl: 'cursus.component.html'
})
export class CursusComponent implements OnInit  {

    @Input() cursus: Cursus;
    @Output() cursusChange: EventEmitter<Cursus> = new EventEmitter();

    @Input() index: number;
    @Input() paysListe: Pays[];
    @Input() deptListe: Departement[];
    @Input() mentionListe: GMention[];
    @Input() isEditable: Boolean;
    @Input() isReinscription: Boolean;
    @Input() candidatureFormationId: number;
    typeFormationListe: TypeFormation[];
    gradeUniversitaireListe: GradeUniversitaire[];
    niveauAccesDiplomeListe: NiveauAccesDiplome[];
    dateFinInvalid = { beforeDateDebut: false, invalid: false };
    constants = CONSTANTS ;
    fr: any;

    constructor(public grhumService: GrhumService,
                public formationService: FormationService,
                public candidatureFormationService: CandidatureFormationService) {
    }

    ngOnInit() {
        this.grhumService.queryTypeFormation().subscribe(
            (res: Response) => { this.typeFormationListe = res.json(); });
        this.grhumService.queryGradeUniversitaire().subscribe(
            (res: Response) => { this.gradeUniversitaireListe = res.json(); });
        this.grhumService.queryNiveauAccesDiplome().subscribe(
            (res: Response) => { this.niveauAccesDiplomeListe = res.json(); });
        if (this.isReinscription && this.cursus.titreDiplomePrepare == null && this.candidatureFormationId != null) {
            this.candidatureFormationService.findLastFormationENS(this.candidatureFormationId).subscribe(
                (res) => { this.cursus.titreDiplomePrepare = res; });
        }
        this.fr = CALENDAR_FR;
    }

    checkDates(date) {
        this.dateFinInvalid.invalid = false;

        this.dateFinInvalid.beforeDateDebut = this.cursus.dateDebut && this.cursus.dateFin && this.cursus.dateDebut > this.cursus.dateFin;
        if (this.cursus.dateDebut > new Date()) {
            this.dateFinInvalid.invalid = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/scolarite/cursus/cursus.component.ts